import { useSelector } from 'react-redux'
import { URL_DOCUMENT_REVIEW_HISTORY } from 'constants/links'
import useObservable from 'libraries/front-end-core/hooks/useObservable'
import selectUserAccessRoles from 'redux/selectors/selectAccessRoles'
import Icon from 'components/shared/Icon'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import { $user } from 'services/SessionService'

function ReviewLinkContent ({ isLogged, accessRoles }: { isLogged: boolean, accessRoles: string[] }): JSX.Element | null {
  return ((!isLogged) || (isLogged && accessRoles.some(role => role.includes('documents_docdrafter'))))
    ? (
      <a
        className='flex justify-center items-center mh4 no-underline'
        href={URL_DOCUMENT_REVIEW_HISTORY}
        target='_blank'
        rel='noreferrer'
      >
        <Icon name='icon-clock' className='w7 mr2' />
        Automated document review history
      </a>
      )
    : null
}

export default function ReviewLink (): JSX.Element {
  const userResponse = useObservable($user)
  const accessRoles = useSelector(selectUserAccessRoles)

  return (
    <ResponseConsumer
      response={userResponse}
      content={() => <ReviewLinkContent accessRoles={accessRoles} isLogged />}
      unauthorizedComponent={() => <ReviewLinkContent accessRoles={[]} isLogged={false} />}
      pendingComponent={undefined}
    />
  )
}
